import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const navLinks = [
    { id: 'strategies',    key: 'nav.strategies' },
    { id: 'calculator',    key: 'nav.calculator' },
    { id: 'how-it-works',  key: 'nav.howItWorks' },
    { id: 'why-scrooge',   key: 'footer.links.whyScrooge' },
    { id: 'security',      key: 'nav.security' },
    { id: 'partners',      key: 'nav.partners' },
    { id: 'live-activity', key: 'footer.links.liveActivity' },
    { id: 'faq',           key: 'nav.faq' },
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true">
                <defs>
                  <linearGradient id="footerLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FFD56B" />
                    <stop offset="100%" stopColor="#E0A820" />
                  </linearGradient>
                </defs>
                <polygon
                  points="16,2 28,9 28,23 16,30 4,23 4,9"
                  fill="none"
                  stroke="url(#footerLogoGrad)"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <text
                  x="16"
                  y="22"
                  textAnchor="middle"
                  fontFamily="Inter, sans-serif"
                  fontSize="16"
                  fontWeight="900"
                  fill="url(#footerLogoGrad)"
                >
                  S
                </text>
              </svg>
              <div className="footer__brand-text">
                <span className="footer__brand-name">SCROOGE</span>
                <span className="footer__brand-sub mono">FINANCE</span>
              </div>
            </div>
            <p className="footer__tagline">{t('footer.tagline')}</p>
            <div className="footer__chain-badge mono">
              <i className="fas fa-circle-check" />
              {t('footer.chain')}
            </div>
          </div>

          <div className="footer__col">
            <h5 className="footer__col-title mono">{t('footer.col.product')}</h5>
            <ul className="footer__links">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(l.id);
                    }}
                  >
                    {t(l.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h5 className="footer__col-title mono">{t('footer.col.resources')}</h5>
            <ul className="footer__links">
              <li>
                <a href="/audit.pdf" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-file-pdf" /> {t('footer.links.audit')}
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/scrooge-finance"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-github" /> {t('footer.links.github')}
                </a>
              </li>
              <li>
                <a
                  href="https://bscscan.com/address/0x0000000000000000000000000000000000000000"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-file-contract" /> {t('footer.links.contract')}
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <i className="fas fa-book" /> {t('footer.links.docs')}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h5 className="footer__col-title mono">{t('footer.col.community')}</h5>
            <ul className="footer__links">
              <li>
                <a
                  href="https://t.me/scrooge_finance_news"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-telegram-plane" /> {t('footer.links.telegramNews')}
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/scrooge_finance_group"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-users" /> {t('footer.links.telegramGroup')}
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/scrooge_finance_group"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-headset" /> {t('footer.links.telegramSupport')}
                </a>
              </li>
              <li>
                <a href="#" onClick={(e) => e.preventDefault()}>
                  <i className="fab fa-x-twitter" /> {t('footer.links.twitter')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p className="footer__copyright">{t('footer.copyright')}</p>
          <p className="footer__disclosure mono">{t('footer.disclosure')}</p>
          <div className="footer__legal">
            <a href="#" onClick={(e) => e.preventDefault()}>{t('footer.terms')}</a>
            <a href="#" onClick={(e) => e.preventDefault()}>{t('footer.privacy')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
